import React from "react";
import ItemRow from "@/components/ItemRow";
import { EmptyState } from "@/components/EmptyState";
import { relativeDateLabel } from "@/lib/dates";

// Reminders tab body — search-result mode + normal today-list mode.
export default function ReminderList({
    q, query, searchLoading, results,
    today, reminders,
    onSearchToggle, onSearchDelete,
    onToggleReminder, onDeleteReminder, onEditReminder, onOpenEditReminder,
    onStartFocus, pomodoro,
}) {
    if (q) {
        if (results.length === 0) {
            return <EmptyState text={searchLoading ? "Searching…" : `No reminders match "${query}".`} />;
        }
        return results.map((r) => (
            <ItemRow
                key={r.id}
                title={r.title}
                completed={r.completed}
                time={r.time}
                dateChip={relativeDateLabel(r.date, today)}
                onToggle={() => onSearchToggle(r)}
                onDelete={() => onSearchDelete(r)}
                onOpenEdit={onOpenEditReminder ? () => onOpenEditReminder(r) : undefined}
                testId={`reminder-row-${r.id}`}
            />
        ));
    }
    return (
        <>
            {reminders.length === 0 && <EmptyState text="No reminders for today. All clear ☁️" />}
            {reminders.map((r) => (
                <ItemRow
                    key={r.id}
                    title={r.title}
                    completed={r.completed}
                    time={r.time}
                    showCountdown={!r.rested}
                    statusLabel={r.rested && !r.completed ? "rested for today" : undefined}
                    onToggle={() => onToggleReminder(r)}
                    onDelete={() => onDeleteReminder(r)}
                    onStartFocus={(focusMin, breakMin) => onStartFocus(r, focusMin, breakMin)}
                    isFocusing={pomodoro?.reminderId === r.id}
                    onEditTime={onEditReminder ? (next) => onEditReminder(r, { time: next }) : undefined}
                    onEditTitle={onEditReminder ? (next) => onEditReminder(r, { title: next }) : undefined}
                    onEditLead={onEditReminder ? (next) => onEditReminder(r, { lead_minutes: next }) : undefined}
                    onOpenEdit={onOpenEditReminder ? () => onOpenEditReminder(r) : undefined}
                    currentLead={r.lead_minutes}
                    testId={`reminder-row-${r.id}`}
                />
            ))}
        </>
    );
}
